<template>
  <div class="w-full bg-white">
    <div class="container mx-auto max-w-custom flex p-[5px] relative items-center">
      <router-link to="/home" class="flex items-center">
        <HeaderLogo class="w-[200px] h-[50px]" />
      </router-link>
      <div class="flex-1 flex justify-end" v-if="user">
        <div 
        v-for="item in headers" 
        :key="item.route" 
        class="flex items-center justify-center py-px">
          <LinkComponent :text="item.title" :link="item.route" :inner="item.children" type="upper"/>
        </div>
        <UserIcon class="mx-2" :userMenu="userMenu"/>
      </div>
      <LanguageSelector class="ml-auto"/>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/Header/HeaderLogo.vue'
import LinkComponent from '@/Header/Desktop/LinkComponent.vue'
import UserIcon from '@/Header/Desktop/UserIcon.vue'
import LanguageSelector from '@/Header/Desktop/LanguageSelector.vue'

export default {
  name: 'UpperHeader',
  props: {
    headers: {
      type: Object,
      required: true
    },
    userMenu: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    HeaderLogo,
    LinkComponent,
    UserIcon,
    LanguageSelector
  },
  data() {
    return {
      user: null
    }
  },
  mounted() {
    this.user = this.$userStore.user
  },
  watch: {
    $route() {
      this.user = this.$userStore.user
    }
  }
}
</script>